<template>
  <div>
    <div class="alert alert-danger" v-if="errorMsg">{{ errorMsg }}</div>

    <div class="row mb-2">
      <div class="col-auto">
        <button class="btn btn-primary gdq_faded gdq-font-size-80" @click="addNew">
          <span class="icon-plus mr-1"></span>Add step
        </button>
      </div>
    </div>

    <div class="card mb-3" v-if="showForm">
      <div class="card-body">
        <h6 class="card-title">{{ editing.id > 0 ? 'Edit step' : 'New step' }}</h6>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Number</label>
              <div style="width: 67%"><input class="form-control" type="number" v-model.number="editing.number" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Title</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.title" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Subtitle</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.subtitle" /></div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mb-3">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="lhfmark" v-model="editing.facilitator_marked" />
                <label class="form-check-label" for="lhfmark">Facilitator marked</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="lhfinal" v-model="editing.is_final" />
                <label class="form-check-label" for="lhfinal">Final step</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="lhdyn" v-model="editing.is_dynamic" />
                <label class="form-check-label" for="lhdyn">Dynamic (sub-checklist)</label>
              </div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Done label</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.done_label" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Undo label</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.undo_label" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Book e-mail</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.book_email" /></div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label class="col-form-label d-block mb-2">Body (HTML)</label>
          <VueEditor v-model="editing.body" />
        </div>

        <div v-if="editing.is_dynamic">
          <div class="d-flex align-items-center mb-2">
            <label class="col-form-label mb-0">Sub-checklist items</label>
            <button class="btn btn-sm btn-outline-primary ms-3 gdq-font-size-80" @click="addSubstep">
              <span class="icon-plus mr-1"></span>Add item
            </button>
          </div>
          <div class="border rounded p-2 mb-2" v-for="(ss, si) in editing.substeps" :key="si">
            <div class="row">
              <div class="col-1">
                <input class="form-control form-control-sm" type="number" v-model.number="ss.sort" title="Order" />
              </div>
              <div class="col-5">
                <input class="form-control form-control-sm" v-model="ss.title" placeholder="Item title" />
              </div>
              <div class="col-5">
                <input class="form-control form-control-sm" v-model="ss.body" placeholder="Item body text" />
              </div>
              <div class="col-1 text-end">
                <span style="cursor: pointer;" class="text-danger" @click="editing.substeps.splice(si, 1)">
                  <fa-icon name="trash-alt" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <button class="btn btn-outline-secondary" @click="cancel">Cancel</button>
          <button class="btn btn-primary float-end" :disabled="saving" @click="save">
            <fa-icon name="check" />Save step
          </button>
        </div>
      </div>
    </div>

    <table class="table table-hover lh-table">
      <thead>
        <tr>
          <th style="width: 50px;">#</th>
          <th>Title</th>
          <th>Flags</th>
          <th>Sub-items</th>
          <th style="width: 110px;">⚡</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in rows" :key="item.id" style="cursor: pointer;" @click="editRow(item)">
          <td>{{ item.number }}</td>
          <td>
            {{ item.title }}
            <small class="text-muted d-block">{{ item.subtitle }}</small>
          </td>
          <td>
            <span class="badge bg-light text-dark" v-if="item.facilitator_marked">facilitator</span>
            <span class="badge bg-light text-dark" v-if="item.is_final">final</span>
            <span class="badge bg-light text-dark" v-if="item.is_dynamic">dynamic</span>
          </td>
          <td>{{ (item.substeps || []).length }}</td>
          <td>
            <span class="me-2" style="cursor: pointer;" title="Move up" v-if="i > 0" @click.prevent.stop="move(item, i, -1)">
              <fa-icon name="arrow-up" />
            </span>
            <span class="me-2" style="cursor: pointer;" title="Move down" v-if="i < rows.length - 1" @click.prevent.stop="move(item, i, 1)">
              <fa-icon name="arrow-down" />
            </span>
            <span style="cursor: pointer;" title="Delete" @click.prevent.stop="delRow(item)">
              <fa-icon name="trash-alt" />
            </span>
          </td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="5" class="text-center text-muted py-3">No steps</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VueEditor from '../CustomControls/VueEditor.vue'

export default {
  name: 'LHCourseSteps',
  components: { VueEditor },
  props: {
    courseId: { type: Number, required: true },
    rows: { type: Array, required: true }
  },
  data () {
    return {
      showForm: false,
      saving: false,
      errorMsg: '',
      editing: this.emptyRow()
    }
  },
  methods: {
    emptyRow () {
      return {
        id: 0, number: 0, title: '', subtitle: '', body: '',
        facilitator_marked: false, is_final: false, is_dynamic: false,
        done_label: '', undo_label: '', book_email: '', substeps: []
      }
    },
    addNew () {
      this.errorMsg = ''
      this.editing = this.emptyRow()
      this.editing.number = this.rows.length > 0 ? Math.max(...this.rows.map(x => Number(x.number) || 0)) + 1 : 1
      this.showForm = true
    },
    editRow (r) {
      this.errorMsg = ''
      this.editing = {
        ...r,
        facilitator_marked: !!r.facilitator_marked,
        is_final: !!r.is_final,
        is_dynamic: !!r.is_dynamic,
        substeps: (r.substeps || []).map(x => ({ ...x }))
      }
      this.showForm = true
    },
    cancel () {
      this.showForm = false
    },
    addSubstep () {
      this.editing.substeps.push({ id: 0, sort: this.editing.substeps.length + 1, title: '', body: '' })
    },
    async save () {
      this.saving = true
      this.errorMsg = ''
      try {
        const body = {
          number: this.editing.number,
          title: this.editing.title,
          subtitle: this.editing.subtitle,
          body: this.editing.body,
          facilitator_marked: this.editing.facilitator_marked ? 1 : 0,
          is_final: this.editing.is_final ? 1 : 0,
          is_dynamic: this.editing.is_dynamic ? 1 : 0,
          done_label: this.editing.done_label,
          undo_label: this.editing.undo_label,
          book_email: this.editing.book_email
        }
        let stepId = this.editing.id
        if (stepId > 0) {
          await this.$store.dispatch('learninghub_step_update', { id: stepId, body })
        } else {
          body.course_id = this.courseId
          const res = await this.$store.dispatch('learninghub_step_save', { body })
          stepId = res.data.result.id
        }
        {
          const existing = (this.rows.find(x => x.id === stepId) || { substeps: [] }).substeps || []
          for (const ss of existing) {
            const keep = this.editing.is_dynamic ? this.editing.substeps.find(x => x.id === ss.id) : null
            if (!keep) {
              await this.$store.dispatch('learninghub_substep_delete', { id: ss.id })
            }
          }
          if (!this.editing.is_dynamic) {
            this.showForm = false
            this.$emit('changed')
            this.saving = false
            return
          }
          for (const ss of this.editing.substeps) {
            const sbody = { sort: ss.sort, title: ss.title, body: ss.body }
            if (ss.id > 0) {
              await this.$store.dispatch('learninghub_substep_update', { id: ss.id, body: sbody })
            } else {
              await this.$store.dispatch('learninghub_substep_save', { body: { step_id: stepId, ...sbody } })
            }
          }
        }
        this.showForm = false
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Save failed')
      }
      this.saving = false
    },
    async delRow (r) {
      if (!confirm('Delete step "' + r.title + '"? Its sub-checklist items and participant progress on it will be deleted.')) return
      try {
        await this.$store.dispatch('learninghub_step_delete', { id: r.id })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Delete failed')
      }
    },
    async move (item, i, dir) {
      const ids = this.rows.map(x => x.id)
      const j = i + dir
      ;[ids[i], ids[j]] = [ids[j], ids[i]]
      try {
        await this.$store.dispatch('learninghub_reorder', { body: { entity: 'step', ids } })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.message || 'Reorder failed'
      }
    }
  }
}
</script>

<style>
.lh-table {
  font-size: 0.9rem !important;
}
</style>
